import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

type ISelectCellResponse = string[];

class SelectCell extends PureComponent<IGridCellRenderProps<ISelectCellResponse>> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return cellValue.join("\r\n");
    }
}

export const columnSelect: IClientGridColumn<ISelectCellResponse> = {
    columnType: GridColumnType.select,
    Cell: SelectCell,
};
